var map = {
	"./app-store.svg": 428,
	"./google-play-badge.png": 429,
	"./icons/android-chrome-192x192.png": 928,
	"./icons/android-chrome-512x512.png": 929,
	"./icons/apple-touch-icon.png": 930,
	"./icons/favicon-16x16.png": 931,
	"./icons/favicon-32x32.png": 932,
	"./icons/favicon.ico": 933,
	"./icons/mstile-144x144.png": 934,
	"./icons/mstile-150x150.png": 935,
	"./icons/mstile-310x150.png": 936,
	"./icons/mstile-310x310.png": 937,
	"./icons/mstile-70x70.png": 938,
	"./icons/safari-pinned-tab.svg": 927
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 409;


//////////////////
// WEBPACK FOOTER
// ../src/client/assets .+
// module id = 409
// module chunks = 17